module.exports = __webpack_public_path__ + "img/ALL-LOGO.6523e2c5.svg";